module.exports = __webpack_public_path__ + "c54096802c2d1bad661e66f0ed44dce7.png";